import { render, staticRenderFns } from "./AssetValueShareChartContainer.vue?vue&type=template&id=bccc3e88&"
import script from "./AssetValueShareChartContainer.vue?vue&type=script&lang=js&"
export * from "./AssetValueShareChartContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports